<template>
    <el-container style="width:100%">
        <el-header style="height:auto;">
            <el-form :inline="true" class="demo-form-inline" label-position="right">
                <el-row :gutter="13">
                    <td-permission :permissions="permissionsView">
                        <div slot="havePermission">
                            <el-col>
                                <el-form-item>
                                    <td-button type="primary" @click="btnQuery" :loading="loading">{{ $t('common.USERS_ONLINE') }}</td-button>
                                </el-form-item>
                            </el-col>
                        </div>
                    </td-permission>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :permissions="permissionsView"
                :hasTreeTable="true"
                :stripe="false"
                :columns="columns"
                :hasMutiSelect="false"
                :dataSource="tableData"
                :total="total"
                :rowKey="rowKey"
                :hasPage="false"
                :hasIndex="true"
                :max-height="650"
                ref="onlineList"
                @handleSelect="select"
                @handleSelectAll="select"
            >
            </td-table>
        </el-main>
    </el-container>
</template>
<script>
import Api from './assets/api.js';
export default {
    // 初始化渲染
    components: {},
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.queryList(); // 进行页面初始化数据的加载
    },
    // 监听
    watch: {},
    data() {
        return {
            permissionsView: ['sys:online'],
            roles: ['admin'],
            tableData: [], // 表格数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            rowKey: 'userId',
            selectRows: [],
            columns: [
                // 首列在表格中格式化
                {
                    prop: 'userName',
                    label: this.$t('common.USERNAME'),
                    align: 'left'
                },
                {
                    prop: 'onlineNum',
                    label: this.$t('common.ONLINE_NUM'),
                    align: 'center'
                },
                {
                    prop: 'ip',
                    label: this.$t('common.IP'),
                    align: 'center'
                },
                {
                    prop: 'platform',
                    label: this.$t('common.CLIENT_TYPE'),
                    align: 'center'
                }
            ]
        };
    },
    methods: {
        select: function(selection, row) {
            this.selectRows = selection;
        },
        // 变更每页条数，获取每页条数并查询
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryList();
        },
        // 获取当前页并翻页查询
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryList();
        },
        // 查询数据
        btnQuery() {
            this.currentPage = 1;
            this.queryList();
        },
        // 查询
        queryList() {
            this.loading = true;
            Api.getOnlineUserList('', response => {
                this.tableData = [];
                let json = {};
                if (typeof response.data == 'string') {
                    json = eval('(' + response.data + ')');
                } else {
                    json = response.data;
                }
                if (json.content.length > 0) {
                    for (let index in json.content) {
                        let children = [];
                        let ips = Object.keys(json.content[index].ipMap);
                        for (let ipIndex in ips) {
                            let child = {
                                children: [],
                                userId: ipIndex,
                                userName: json.content[index].sName,
                                onlineNum: '',
                                ip: ips[ipIndex],
                                platform: json.content[index].ipMap[ips[ipIndex]].clientType
                            };
                            children.push(child);
                        }
                        let ip = '';
                        let platform = '';
                        if (ips.length == 1) {
                            ip = ips[0];
                            platform = json.content[index].ipMap[ips[0]].clientType;
                        }
                        let onlineUser = {
                            children: children,
                            userId: json.content[index].sId,
                            userName: json.content[index].sName,
                            onlineNum: children.length,
                            ip: ip,
                            platform: platform
                        };
                        this.tableData.push(onlineUser);
                    }
                    this.total = json.content.length;
                    // let num = this.pageSize * (this.currentPage - 1);
                    // let maxNum = 0;
                    // if (json.content.length < num + this.pageSize) {
                    //     maxNum = num + json.content.length;
                    // } else {
                    //     maxNum = num + this.pageSize;
                    // }
                    // for (let index = num; index < maxNum; index++) {
                    //     let children = [];
                    //     let ips = Object.keys(json.content[index].ipMap);
                    //     for (let ipIndex in ips) {
                    //         let child = {
                    //             children: [],
                    //             userId: ipIndex,
                    //             userName: json.content[index].sName,
                    //             onlineNum: '',
                    //             ip: ips[ipIndex],
                    //             platform: json.content[index].ipMap[ips[ipIndex]].clientType
                    //         };
                    //         children.push(child);
                    //     }
                    //     let ip = '';
                    //     let platform = '';
                    //     if (ips.length == 1) {
                    //         ip = ips[0];
                    //         platform = json.content[index].ipMap[ips[0]].clientType;
                    //     }
                    //     let onlineUser = {
                    //         children: children,
                    //         userId: json.content[index].sId,
                    //         userName: json.content[index].sName,
                    //         onlineNum: children.length,
                    //         ip: ip,
                    //         platform: platform
                    //     };
                    //     this.tableData.push(onlineUser);
                    // }
                    // this.total = json.content.length;
                }
                this.loading = false;
            });
        }
    }
};
</script>
